<template>
  <div class="question-checkbox">
        <vp-checkbox
            :id="id"
            ref="input"
            :value="value"
            class="option"
            :labelFirst="true"
            :disabled="readonly"
            :name="name"
            @focus="handleFocus"
            @blur="handleBlur"
            @input="checked => $emit('input', checked)"
            :styles="{ size: 20, color: theme.primaryColor }"
          >
        </vp-checkbox>
        <label for="question-checkbox"
        class="checkbox-text" style="  font-size: 14px; margin-bottom: -14px;">
          {{ question.checkboxText }}
        </label>
  </div>
</template>

<script>
import defaultTheme from '../../styles/defaultTheme';

export default {
  name: 'question-checkbox',
  props: {
    id: String,
    question: Object,
    name: String,
    value: Boolean,
    readonly: { type: Boolean, default: false },
    disabled: {
      type: Boolean,
      default: false,
    },
    dataType: Boolean,
  },
  inject: {
    theme: { default: defaultTheme },
  },
  mounted() {
    this.$emit('input', false);
  },
  methods: {
    handleFocus(...args) {
      this.$emit('focus', ...args);
    },
    handleBlur() {
      this.$emit('blur');
    },
    handleKeyPress(event) {
      if (event.key === 'Enter') {
        event.preventDefault();
        this.$emit('keyPressEnter');
      }
    },
  },
};
</script>

<style lang="scss">
@import '../../styles/styles.scss';
.question-checkbox {
  display: flex;
  flex-direction: row;
  margin-top: 24px;
  gap: 10px;
  align-items: flex-start;
  label {
    text-align: start;
  }
}
</style>
